<template>
    <svg aria-hidden="true" focusable="false" class="o-ico" :class="classes">
        <use :xlink:href="path + id"></use>
    </svg>
</template>

<script setup>

defineProps({
    id: {
        type: String,
        default: ''
    },
    classes: {
        type: String,
        default: ''
    },
})

const path = WPURLS.svgurl + '#';

</script>
